import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { Done } from '@material-ui/icons';

interface BoardNewActionsProps {
  handleSubmit(): void;
}

const BoardNewActions: React.FC<BoardNewActionsProps> = ({ handleSubmit }) => {
  return (
    <Tooltip title="Salvar">
      <IconButton color="inherit" onClick={handleSubmit}>
        <Done />
      </IconButton>
    </Tooltip>
  );
};

export default BoardNewActions;
